import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const RydeProgressStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ryde-progress",
})<{ $isEndAdornment: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr 1fr;
  align-items: center;
  margin-top: 7px;

  .RydeProgress-Head__container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .RydeProgress-Title {
    grid-column: 1 / 3;
    display: inline-flex;
    align-items: center;
  }

  .RydeProgress-DisplayValue {
    color: ${greyMui._600};
    background-color: ${greyMui._100};
    border-radius: 6px;
    padding: 1px 6px;
    font-size: 12px;
    line-height: 1.4;
    white-space: nowrap;
    margin-inline-start: 10px;
  }

  .RydeProgress-Line {
    height: 10px;
    border-bottom: 2px solid ${greyMui._400};

    ${({ $isEndAdornment }) =>
      $isEndAdornment ? "grid-column: 1 / 2" : "grid-column: 1 / 3"}
  }

  .RydeProgress-EndAdornment {
    grid-column: 2 / 3;
  }

  .RydeProgress-Count {
    color: ${greyMui._600};
    background-color: ${greyMui._100};
    border-radius: 6px;
    padding: 1px 6px;
    font-size: 12px;
    line-height: 1.4;
    white-space: nowrap;
    margin-inline-start: 10px;
  }
`;
